import BaseService from './base.service'

class QrService extends BaseService {
  /**
   * The constructor for the ArtistService.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor (parameters = {}) {
    super('api/qrlink', parameters)
  }
}

export default QrService
